import type { ScrapMixFilterOption } from "../models";

export const ALL_OPTIONS_LABEL = "All";

export const areAllOptionsSelected = (
  options: ScrapMixFilterOption[],
  values: string[],
) => {
  if (options.length === 0) return false;
  const selectedValues = new Set(values);
  return options.every((option) => selectedValues.has(option.Value));
};
